<template>
    <v-container> 
        <v-card hover class="mt-4" height="90px" style="border-radius: 8px;" v-for="(bot,index) in botsList" :key="bot.name" @click="gotoBot(index)">
            <v-layout>
                <v-flex xs2>
            <v-avatar
            :size="60"
            >
                <v-img
                    class="elevation-6 ml-5 mt-1"
                    :src="bot.imageurl"
                ></v-img>
            </v-avatar>
            </v-flex>
                <v-flex xs10>
            <div class="headline mt-3"> {{bot.name}} </div>
            </v-flex>
            </v-layout>
        </v-card>
        <v-card hover class="mt-4" height="90px" style="border-radius: 8px;" to="/settings-newbot">
            <v-layout>
                <v-flex xs5>
                </v-flex>
                <v-flex xs8>
            <div class="headline mt-3"> + Add new bot </div>
            </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</template>

<script>
import fb from '../plugins/fb.js'
export default {
    data(){
        return{
            bots:null
            }
    },
    methods:{
        gotoBot(index){
            let pageid = this.bots[index].id
            console.log(pageid)
            this.$store.dispatch('aSelectedPage',pageid)
            this.$router.push('/automation/responses/'+pageid)
        }
    },
    created(){

    },
    computed:{
        botsList(){ 
            this.bots = this.$store.state.botsList
            console.log(this.bots)
            return this.bots
        },
        
    }    
}
</script>
